import CommonList from "@/components/common/List";
import CommonTableList from "@/components/common/TableList";
import VehicleCreate from "./Create";
import { tableCol } from "@/components/common/columns/columns";
import { ResourceContextProvider } from "react-admin";
import VehicleEdit from "./Edit";

const AutoVehiclesList = () => {
  const columns = tableCol({
    showActions: true,
    columns: [
      {
        accessorKey: "license_plate",
        header: "License plate",
        cell: ({ row }) => {
          return (
            <div className="flex flex-col text-sm space-y-1">
              <span className="font-medium">{row.getValue("license_plate")}</span>
            </div>
          );
        },
      },
      {
        accessorKey: "vin",
        header: "VIN",
        cell: ({ row }) => {
          return (
            <div className="flex flex-col text-sm space-y-1">
              <span className="font-medium">{row.getValue("vin")}</span>
            </div>
          );
        },
      },
      {
        accessorKey: "make",
        header: "Make",
        cell: ({ row }) => {
          return (
            <div className="flex flex-col text-sm space-y-1">
              <span className="font-medium">{row.getValue("make")}</span>
            </div>
          );
        },
      },
      {
        accessorKey: "model",
        header: "Model",
        cell: ({ row }) => {
          return (
            <div className="flex flex-col text-sm space-y-1">
              <span className="font-medium">{row.getValue("model")}</span>
            </div>
          );
        },
      },
      {
        accessorKey: "year",
        header: "Year",
        cell: ({ row }) => {
          return (
            <div className="flex flex-col text-sm space-y-1">
              <span className="font-medium">{row.getValue("year")}</span>
            </div>
          );
        },
      },
    ],
    EditComponent: VehicleEdit,
    resource: 'auto-service/vehicles',
  });

  return (
    <ResourceContextProvider value="auto-service/vehicles">
      <CommonList>
        <CommonTableList
          columns={columns}
          filterSearch="make"
          create={<VehicleCreate />}
        />
      </CommonList>
    </ResourceContextProvider>
  );
};

export default AutoVehiclesList;
